import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  const {
    scrollYProgress
  } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 200,
    damping: 40,
    mass: 0.3
  });
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        window.setTimeout(() => el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        }), 60);
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return <div className="min-h-screen w-full bg-paper" data-id="element-354" data-mp="3j2mhttoxg1ie">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-lg focus:bg-brass focus:px-4 focus:py-2 focus:text-ink" data-id="element-355" data-mp="1kntaihsbxdn3">
        Aller au contenu
      </a>
      <motion.div style={{
      scaleX: progress
    }} className="fixed inset-x-0 top-0 z-[60] h-[3px] origin-left bg-brass" aria-hidden="true" data-id="element-356" data-mp="3n1leu96syrfw" />
      <Navbar data-id="element-357" data-mp="3dah3rkk8zqqc" />
      <main id="contenu" data-id="element-358" data-mp="3dc1wr5qwz1m3">
        <Outlet data-id="element-359" data-mp="3dba2by91z9xe" />
      </main>
      <Footer data-id="element-360" data-mp="38bxh1hxtyawx" />
    </div>;
}